import CameraIcon from "@/icons/CameraIcon";
import { PlayIcon } from "@/icons/PlayIcon";
import { cn } from "@pulsex/utils";
import React from "react";

type MediaProps = {
  className?: string;
  url?: string;
  type?: "video" | "camera";
  color?: string;
  iconClassName?: string;
  size?: number;
};

export const MediaIcon = ({
  className,
  url,
  size,
  type = "camera",
  iconClassName,
  color,
}: MediaProps) => {
  return (
    <>
      {type === "camera" ? (
        <CameraIcon size={size || 25} className={className} color={color} />
      ) : (
        <PlayIcon size={size || 25} className={className} color={color} />
      )}
    </>
  );
};
